import { DextoolsIcon, Flex, getChainIconByNetwork, DexscreenerIcon } from '@mprolab/uikit'
import { dexToolsConfig } from 'config'
import * as React from 'react'
import styled from 'styled-components'

const Wrapper = styled(Flex)`
  gap: 8px;
  padding: 4px 8px;
  border-radius: 32px;
  background: ${({ theme }) => theme.colors.gray7};
  justify-content: center;
  align-items: center;
  width: max-content;
`

const DexTools: React.FC = () => {
  return (
    <Flex flexDirection="row" gap="8px">
      {dexToolsConfig.map((icon) => {
        const { networks, id } = icon
        return (
          <Wrapper key={id}>
            {id === 'Dextools' ? <DextoolsIcon /> : <DexscreenerIcon />}
            {networks.map(({ network, href }, index) => {
              return (
                <Flex key={index} onClick={() => window.open(href, '_blank')} style={{ cursor: 'pointer' }}>
                  {getChainIconByNetwork(network, '16px', '16px')}
                </Flex>
              )
            })}
          </Wrapper>
        )
      })}
    </Flex>
  )
}

export default DexTools
